import React from 'react';

import { createStyles, withStyles } from '@material-ui/core/styles';
import MuiTypography, { TypographyProps as MuiTypographyProps } from '@material-ui/core/Typography';
import classNames from 'classnames';

import { LumaTheme } from '../styles/getTheme';

const styles = (theme: LumaTheme) =>
  createStyles({
    variantCustomHeader: {
      fontWeight: 900,
      textTransform: 'uppercase',
    },
  });

export interface TypographyProps extends Omit<MuiTypographyProps, 'variant'> {
  classes: any;
  variant?: MuiTypographyProps['variant'] | 'customHeader';
}

const Typography: React.FC<TypographyProps> = ({ classes, className, children, variant, ...rest }) => {
  let variantValue: MuiTypographyProps['variant'];
  if (variant === 'customHeader') {
    variantValue = 'h6';
  } else {
    variantValue = variant;
  }

  return (
    <MuiTypography
      className={classNames(
        {
          [classes.variantCustomHeader]: variant === 'customHeader',
        },
        className,
      )}
      variant={variantValue}
      {...rest}
    >
      {children}
    </MuiTypography>
  );
};

export default withStyles(styles)(Typography);
